import React from 'react';
import WName from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// The ™ and ® ??? 
export const tm = {
  name: "tm",
  alternatives: "trademark,trademarks",
  prelude: <span>Someone’s going to <i>sue</i> <QL name="author">you</QL>, <NW>zyzzyva</NW>.</span>,
  question: <span>Why all the ™’s and (and ®’s)?</span>,
  answerPreview: <div className="answer-preview">
    <p>It’s not <i>trying</i> to be (or not ‘<PL name="exclusivity">just</PL>’) <OML>offensive</OML>. It’s a <AL>mirror</AL>.</p>
    <p><QL name="anthropocentrism">Humanity</QL>-2020's is not ‘humanity’. <LRL>We</LRL> are Humanity<sup>®</sup>.</p>
    <p>And the biggest problem with <PL>Mamma</PL> <LRL>Reactivity</LRL> is that ‘she’ isn’t a real ‘mamma’. ‘She’ is literally <AL name="limits.1">incapable</AL> of <PL>love</PL>.</p>
  </div>,
  answer: <div className="answer">
    <p><LRL>Reactivity</LRL> isn’t mamma; it’s <PL>Mamma</PL><sup>™</sup>. With the ‘™’.</p>
    <p>See the <AL name="you">you/YOU<sup>™</sup> divide</AL>.</p>
  </div>,
};
